module.exports = __webpack_public_path__ + "static/media/Slack.06e94d69.svg";